/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var OPTION_INPUT_SELECTOR = '.ProductForm__Option [type="radio"][data-option-position]';
  var MOBILE_OPTION_SELECTOR = '.horizontal__item_[data-option-position]';
  var UNAVAILABLE_CLASS = 'is-unavailable';
  var DISABLED_CLASS = 'is-disabled';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getVariantValue(variant, position) {
    return variant ? variant['option' + position] : null;
  }

  function getOptionPositions(productData) {
    var positions = [];
    var optionCount = productData && productData.options ? productData.options.length : 0;

    for (var i = 1; i <= Math.min(optionCount || 3, 3); i++) {
      positions.push(String(i));
    }

    if (positions.length === 0 && productData && productData.variants) {
      [1, 2, 3].forEach(function(position) {
        var key = 'option' + position;
        var hasValue = productData.variants.some(function(variant) {
          return variant[key] !== null && typeof variant[key] !== 'undefined';
        });

        if (hasValue) {
          positions.push(String(position));
        }
      });
    }

    return positions;
  }

  function readProductData(section) {
    var jsonElement = section.querySelector('[data-product-json]');

    if (!jsonElement) {
      return null;
    }

    try {
      return JSON.parse(jsonElement.textContent).product;
    } catch (error) {
      return null;
    }
  }

  function findLabelForInput(section, input) {
    if (!input.id) {
      return null;
    }

    return section.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
  }

  function getSelectedOptions(section, optionPositions) {
    var selectedOptions = {};

    optionPositions.forEach(function(position) {
      selectedOptions['option' + position] = null;
    });

    toArray(section.querySelectorAll(OPTION_INPUT_SELECTOR + ':checked')).forEach(function(input) {
      selectedOptions['option' + input.getAttribute('data-option-position')] = input.value;
    });

    return selectedOptions;
  }

  function variantMatchesOptions(variant, optionPositions, selectedOptions) {
    return optionPositions.every(function(position) {
      var key = 'option' + position;
      return selectedOptions[key] === null || getVariantValue(variant, position) === selectedOptions[key];
    });
  }

  function findExactVariant(variants, optionPositions, selectedOptions) {
    var hasCompleteOptions = optionPositions.every(function(position) {
      return selectedOptions['option' + position] !== null;
    });

    if (!hasCompleteOptions) {
      return null;
    }

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var matches = optionPositions.every(function(position) {
        return getVariantValue(variant, position) === selectedOptions['option' + position];
      });

      if (matches) {
        return variant;
      }
    }

    return null;
  }

  function findFallbackVariant(variants, optionPositions, selectedOptions, changedPosition, changedValue) {
    var candidates = variants.filter(function(variant) {
      return getVariantValue(variant, changedPosition) === changedValue;
    });

    if (candidates.length === 0) {
      return null;
    }

    return candidates
      .map(function(variant, index) {
        var score = 0;

        optionPositions.forEach(function(position) {
          var key = 'option' + position;

          if (String(position) !== String(changedPosition) && selectedOptions[key] !== null && getVariantValue(variant, position) === selectedOptions[key]) {
            score += 1;
          }
        });

        return {
          variant: variant,
          index: index,
          score: score
        };
      })
      .sort(function(a, b) {
        if (b.score !== a.score) {
          return b.score - a.score;
        }

        return a.index - b.index;
      })[0].variant;
  }

  function hasVariantForValue(variants, optionPositions, selectedOptions, position, value) {
    var trialOptions = {};

    optionPositions.forEach(function(optionPosition) {
      var key = 'option' + optionPosition;
      trialOptions[key] = String(optionPosition) === String(position) ? value : selectedOptions[key];
    });

    return variants.some(function(variant) {
      return variantMatchesOptions(variant, optionPositions, trialOptions);
    });
  }

  function valueExistsInAnyVariant(variants, position, value) {
    return variants.some(function(variant) {
      return getVariantValue(variant, position) === value;
    });
  }

  function setOptionElementState(element, isUnavailable, isDisabled) {
    element.classList.toggle(UNAVAILABLE_CLASS, isUnavailable);
    element.classList.toggle(DISABLED_CLASS, isDisabled);
    element.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');

    if (isDisabled) {
      element.setAttribute('data-variant-option-disabled', 'true');
    } else {
      element.removeAttribute('data-variant-option-disabled');
    }
  }

  function syncMobileCheckedState(section, selectedOptions) {
    toArray(section.querySelectorAll(MOBILE_OPTION_SELECTOR)).forEach(function(item) {
      var position = item.getAttribute('data-option-position');
      var value = item.getAttribute('value');

      if (selectedOptions['option' + position] === value) {
        item.setAttribute('checked', 'checked');
      } else {
        item.removeAttribute('checked');
      }
    });
  }

  function updateAvailability(section, productData, optionPositions) {
    var variants = productData.variants || [];
    var selectedOptions = getSelectedOptions(section, optionPositions);

    toArray(section.querySelectorAll(OPTION_INPUT_SELECTOR)).forEach(function(input) {
      var position = input.getAttribute('data-option-position');
      var isUnavailable = !hasVariantForValue(variants, optionPositions, selectedOptions, position, input.value);
      var isDisabled = !valueExistsInAnyVariant(variants, position, input.value);
      var label = findLabelForInput(section, input);

      input.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
      if (isDisabled) {
        input.setAttribute('data-variant-option-disabled', 'true');
      } else {
        input.removeAttribute('data-variant-option-disabled');
      }

      if (label) {
        setOptionElementState(label, isUnavailable, isDisabled);
      }
    });

    toArray(section.querySelectorAll(MOBILE_OPTION_SELECTOR)).forEach(function(item) {
      var position = item.getAttribute('data-option-position');
      var value = item.getAttribute('value');
      var isUnavailable = !hasVariantForValue(variants, optionPositions, selectedOptions, position, value);
      var isDisabled = !valueExistsInAnyVariant(variants, position, value);

      setOptionElementState(item, isUnavailable, isDisabled);
    });

    syncMobileCheckedState(section, selectedOptions);
  }

  function getMasterSelector(section, productData) {
    return section.querySelector('#product-select-' + productData.id) || section.querySelector('form.ProductForm [name="id"]');
  }

  function getSectionSettings(section) {
    var rawSettings = section.getAttribute('data-section-settings');

    if (!rawSettings) {
      return {};
    }

    try {
      return JSON.parse(rawSettings);
    } catch (error) {
      return {};
    }
  }

  function getCurrentVariantFromOptions(productData, optionPositions, selectedOptions) {
    return findExactVariant(productData.variants || [], optionPositions, selectedOptions);
  }

  function updateMobileDirectAddButton(section, productData, optionPositions) {
    var mobileButton = section.querySelector('.mobile_direct_selector .ProductForm__AddToCart');

    if (!mobileButton) {
      return;
    }

    var selectedOptions = getSelectedOptions(section, optionPositions);
    var variant = getCurrentVariantFromOptions(productData, optionPositions, selectedOptions);
    var sectionSettings = getSectionSettings(section);
    var addToCartText = window.languages && window.languages.productFormAddToCart ? window.languages.productFormAddToCart : 'Add to Cart';
    var preOrderText = window.languages && window.languages.productFormPreOrder ? window.languages.productFormPreOrder : addToCartText;
    var soldOutText = window.languages && window.languages.productFormSoldOut ? window.languages.productFormSoldOut : 'Sold Out';
    var unavailableText = window.languages && window.languages.productFormUnavailable ? window.languages.productFormUnavailable : 'Unavailable';

    if (!variant) {
      mobileButton.setAttribute('disabled', 'disabled');
      mobileButton.textContent = unavailableText;
      return;
    }

    if (variant.available) {
      mobileButton.removeAttribute('disabled');
      mobileButton.textContent = sectionSettings.templateSuffix === 'pre-order' ? preOrderText : addToCartText;
    } else {
      mobileButton.setAttribute('disabled', 'disabled');
      mobileButton.textContent = soldOutText;
    }
  }

  function setMasterVariant(section, productData, variant) {
    var masterSelector = getMasterSelector(section, productData);

    if (!masterSelector || !variant) {
      return;
    }

    masterSelector.value = variant.id;
  }

  function syncToVariant(section, productData, optionPositions, variant, originatingInput) {
    var changedInputs = [];

    optionPositions.forEach(function(position) {
      var value = getVariantValue(variant, position);
      var inputs = toArray(section.querySelectorAll(OPTION_INPUT_SELECTOR)).filter(function(input) {
        return input.getAttribute('data-option-position') === String(position);
      });

      inputs.forEach(function(input) {
        var shouldCheck = input.value === value;

        if (input.checked !== shouldCheck) {
          input.checked = shouldCheck;

          if (shouldCheck) {
            changedInputs.push(input);
          }
        }
      });
    });

    setMasterVariant(section, productData, variant);
    updateMobileDirectAddButton(section, productData, optionPositions);

    changedInputs.forEach(function(input) {
      if (originatingInput && input === originatingInput) {
        return;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    syncMobileCheckedState(section, getSelectedOptions(section, optionPositions));
  }

  function initProductOptionAvailability(section) {
    if (!section || section.getAttribute('data-variant-option-availability') === 'true') {
      return;
    }

    var productData = readProductData(section);

    if (!productData || !productData.variants || productData.variants.length === 0) {
      return;
    }

    var optionPositions = getOptionPositions(productData);

    if (optionPositions.length < 2) {
      return;
    }

    section.setAttribute('data-variant-option-availability', 'true');

    section.addEventListener('click', function(event) {
      var mobileItem = event.target.closest ? event.target.closest(MOBILE_OPTION_SELECTOR) : null;

      if (!mobileItem || !section.contains(mobileItem)) {
        return;
      }

      if (mobileItem.getAttribute('data-variant-option-disabled') === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    section.addEventListener('change', function(event) {
      var input = event.target.closest ? event.target.closest(OPTION_INPUT_SELECTOR) : null;

      if (!input || !section.contains(input)) {
        return;
      }

      var selectedOptions = getSelectedOptions(section, optionPositions);
      var exactVariant = findExactVariant(productData.variants, optionPositions, selectedOptions);

      if (!exactVariant) {
        var changedPosition = input.getAttribute('data-option-position');
        var fallbackVariant = findFallbackVariant(productData.variants, optionPositions, selectedOptions, changedPosition, input.value);

        if (fallbackVariant) {
          syncToVariant(section, productData, optionPositions, fallbackVariant, input);
        }
      }

      window.setTimeout(function() {
        updateAvailability(section, productData, optionPositions);
        updateMobileDirectAddButton(section, productData, optionPositions);
      }, 0);
    }, true);

    section.addEventListener('variant:changed', function() {
      window.setTimeout(function() {
        updateAvailability(section, productData, optionPositions);
        updateMobileDirectAddButton(section, productData, optionPositions);
      }, 0);
    });

    updateAvailability(section, productData, optionPositions);
    updateMobileDirectAddButton(section, productData, optionPositions);
  }

  function initAllProductOptionAvailability() {
    toArray(document.querySelectorAll(PRODUCT_SECTION_SELECTOR)).forEach(initProductOptionAvailability);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductOptionAvailability);
  } else {
    initAllProductOptionAvailability();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initProductOptionAvailability(event.target);
  });
})();
